// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "serializers-module--arrow-up-and-down--af6d4";
export var embbededImageWrapper = "serializers-module--embbededImageWrapper--61e71";
export var emptyParagraph = "serializers-module--emptyParagraph--4cb23";
export var gridList = "serializers-module--gridList--731c6";
export var line = "serializers-module--line--892bd";
export var link = "serializers-module--link--bf38e";
export var linkIcon = "serializers-module--linkIcon--f00ba";
export var linksContainer = "serializers-module--linksContainer--d7b1c";
export var linksGridContainer = "serializers-module--linksGridContainer--0c404";
export var list = "serializers-module--list--8f792";
export var listItem = "serializers-module--listItem--4480e";
export var logoContainer = "serializers-module--logoContainer--e6713";
export var logoImageContainer = "serializers-module--logoImageContainer--79f06";
export var logoTitle = "serializers-module--logoTitle--c56ff";
export var numberAndLine = "serializers-module--numberAndLine--3e3ed";
export var numberContainer = "serializers-module--numberContainer--3e903";
export var numberWrapper = "serializers-module--numberWrapper--dc0dc";
export var numberedList = "serializers-module--numberedList--9e016";
export var simpleList = "serializers-module--simpleList--e79af";
export var textContainer = "serializers-module--textContainer--a3b66";
export var videoContainer = "serializers-module--videoContainer--65b0e";
export var videoTranscriptionLink = "serializers-module--videoTranscriptionLink--9bd9e";